export const handleAccessibilityClick = (event: any) => {
  if (event.type === "click") {
    return true;
  }
  if (event.type === "keydown") {
    const code = event.charCode || event.keyCode;
    if (code === 32 || code === 13) {
      return true;
    }
  }
  return false;
};
try {
    // @ts-ignore
    handleAccessibilityClick.displayName = "handleAccessibilityClick";
    // @ts-ignore
    handleAccessibilityClick.__docgenInfo = { "description": "", "displayName": "handleAccessibilityClick", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/utils/handleAccessibilityClick.ts#handleAccessibilityClick"] = { docgenInfo: handleAccessibilityClick.__docgenInfo, name: "handleAccessibilityClick", path: "src/utils/handleAccessibilityClick.ts#handleAccessibilityClick" };
}
catch (__react_docgen_typescript_loader_error) { }